module.exports = __webpack_public_path__ + "static/media/mail.2be3d3e8.svg";